import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const useMember = () => {
    const history = useHistory();
    const getToken = () => {
        const memberString = localStorage.getItem('member');
        let memberToken;

        try {
            if (memberString) {
                memberToken = JSON.parse(memberString);
                console.log('memberToken? ', memberToken);
            }
        } catch (e: any) {
            console.error('JSON Parse error:', e.message);
            localStorage.removeItem('member');
            memberToken = null;
            history.push('/');
        }

        return memberToken;
    };

    const [member, setMember] = useState(getToken());

    const saveMember = (memberToken: any) => {
        console.log('in saveMember token ', memberToken);
        localStorage.setItem('member', JSON.stringify(memberToken));
        setMember(memberToken);
    };

    const deleteMember = () => {
        localStorage.removeItem('member');
        setMember(null);
    };

    useEffect(() => {
        console.log('member is changed!', member);
        // saveMember(member)
    }, [member]);

    return {
        member,
        setMember: saveMember,
        deleteMember: deleteMember,
        // seveMember: saveMember,
    };
};

export default useMember;
